import { defineStore } from 'pinia';
import { find, reduce, map, pickBy } from 'lodash-es';
import JSON5 from 'json5';
import { getSysDict } from '@/api/dict';

export const useDictStore = defineStore('dictStore', {
  state: () => ({
    sysDict: useSessionStorage('sysDict', {}, { serializer: { read: JSON5.parse, write: JSON5.stringify } }),
  }),
  getters: {
    zcDict: (state) => {
      return new Map<string, any[]>(
        map(state.sysDict as Record<string, any[]>, (v, k) => [
          k,
          map(v, (d) => ({
            ...d,
            dictValue: d.value,
            dictLabel: d.label,
          })),
        ]),
      );
    },
    getDict() {
      return (dictType: string, dictValue: string) => {
        const items = this.zcDict.get(dictType);
        if (items) return find(items, (item: any) => item.dictValue === dictValue);
      };
    },
    //  根据字典dictValue值查找对应dictLabel
    getLabel() {
      return (dictType: string, dictValue: string, defaultLabel = '-') => {
        const items = this.zcDict.get(dictType);
        if (!items) return defaultLabel;
        const item = find(items, (item: any) => item.dictValue === dictValue);
        return item?.dictLabel || defaultLabel;
      };
    },
  },
  actions: {
    resetDict() {
      this.sysDict = {};
    },
    async getSysDict() {
      try {
        const res: any = await getSysDict();
        this.sysDict = reduce(
          res.data,
          (r, v, k) => {
            if (v[0]?.dicList?.length)
              return {
                ...r,
                [k]: map(v[0].dicList, (d) => pickBy(d, (dv, dk) => !!dv && dk !== 'dict_type')),
              };
            return r;
          },
          {},
        );
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
});
